import { api } from "../api/callApi";
import { urlTenant } from "../api/v1";
import { OPERATION_MODE } from "../varibles/constants";
import { ISite } from "../varibles/interface";

interface IEditWeatherStatusFetch {
    tenant_id: string,
    weather_license: boolean
}

interface ICreateTenantFetch {
    name: string,
    weather_license: boolean,
    customer_type: string,
    domain: {
        provider_name: string,
        name: string,
        sso_mode: string
    },
    integration_mode: string,
    integration: {
        pass: string,
        user: string,
        type: string,
        url: string
    }
}

interface IUpdateTenantFetch {
    id: string
    name: string
    weather_license: boolean
    customer_type: string
    domain: {
        provider_name: string
        name: string
        sso_mode: string
    }
    integration_mode: string
    integration: {
        pass: string
        user: string
        type: string
        url: string
    }
}

interface IGenerateSitesFetch {
    tenant_id: string
    business_name: string
}

interface IUpdateDensity {
    density?: {
        [index: string]: number[]
    }
    enable_change_operation_status?: boolean
    operation_mode?: OPERATION_MODE
}

export const TenantService = {
    getTenants: () => api.get(urlTenant),
    editWeatherStatus: (data: IEditWeatherStatusFetch) => api.put(urlTenant + '/weather', data),
    createTenant: (params: ICreateTenantFetch) => api.post(urlTenant, params),
    updateTenant: (params: IUpdateTenantFetch) => api.put(urlTenant, params),
    generateSites: (params: IGenerateSitesFetch) => api.post<ISite[]>(urlTenant + '/trial', params),
    saveGenerate: (params: { sites: ISite[] }) => api.put(urlTenant + '/trial', params),
    updateSettingTenant: (body: IUpdateDensity) => api.put(urlTenant + '/setting', body),
}